import { render, staticRenderFns } from "./CustomerRequestMiscStep.vue?vue&type=template&id=53bd09e8&"
import script from "./CustomerRequestMiscStep.vue?vue&type=script&lang=js&"
export * from "./CustomerRequestMiscStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports